module.exports = __webpack_public_path__ + "odinstatic/v5.0.2/media/Ham_menu.04090ea8.svg";